export const extractAccessories = (arg) => {
  const { accessories, accessoriesListInfo, } = arg;
  if (!accessories || accessories.length === 0) return {};

  return {
    subTotal: accessories.reduce((acc, accessory) => {
      const acc_qty = accessory.quantity || 1;
      const sv = accessoriesListInfo.find((info) => info.id === accessory.product_id).selected_variant;
      return acc + (sv.price * acc_qty)
    }, 0),
    selected: true,
  };
}